import {Component, Prop, Vue} from "vue-property-decorator"
import {songs} from "@/main"
import Song from "@/song"
import router from "@/router"

// noinspection JSUnusedGlobalSymbols - Required by Vue to be "export default"
@Component
export default class SongView extends Vue {

  @Prop({type: String, required: true})
  private songName!: string

  get toolbarClass(): string {
    return this.songChords ? "md-large " : ""
  }

  get chordsVisibility(): string {
    return this.songChords ? "" : "none"
  }

  get song(): Song | undefined {
    return songs.find(it => it.name === this.songName)
  }

  get lyricsParagraphs(): string[] {
    const song = this.song
    if (song === undefined) {
      return []
    }
    return song.lyrics.split("\n\n")
  }

  get songChords(): string {
    // Copy reference so that it can't change out under us (thread safety)
    const song = this.song
    return song !== undefined && song.chords !== undefined ? song.chords : ""
  }

  // noinspection JSUnusedGlobalSymbols - Lifecycle callback from Vue
  public mounted() {
    document.title = this.songName
  }

  // noinspection JSUnusedLocalSymbols, JSMethodCanBeStatic - used by Vue template; can't be static
  private splitLines(paragraph: string): string[] {
    return paragraph.split("\n")
  }

  // noinspection JSUnusedLocalSymbols, JSMethodCanBeStatic - used by Vue template; can't be static
  private navigateUp(): void {
    if (history.state) {
      router.back()
    } else {
      router.push("/")
    }
  }
}
